import React, { type HTMLAttributes } from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';

import { CoreLink, Paragraph } from '@uncinc/react-drupal-core';
import { useWindowDimensions, Container } from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Hero, WysiwygField } from '../../../../components';
import { SCREEN_TABLET } from '../../../../config/constants';
import type { NodeLandingPage as Type } from '../../../../types/uncinc_profile/nodes';

import './style.scss';

interface LandingPageProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const NodeLandingPageMaatjes: React.FC<LandingPageProps> = ({
  entity,
  className,
}) => {
  const { width } = useWindowDimensions();
  const isMobile = width < SCREEN_TABLET;
  const classes = classNames(className, 'NodeLandingPageMaatjes');
  const landingPage = entity.toJS();
  const title = landingPage.title[0].value;
  const body = landingPage.body[0]?.processed;
  const linkTitle = landingPage.field_link[0]?.title;
  const linkUri = landingPage.field_link[0]?.alias || landingPage.field_link[0]?.uri || null;
  const secondaryLinkTitle = landingPage.field_link_secondary[0]?.title;
  const secondaryLinkUri = landingPage.field_link_secondary[0]?.alias ||
    landingPage.field_link_secondary[0]?.uri || null;
  const paragraphs = landingPage.field_paragraphs;
  const media = landingPage.field_media_item[0];
  const { bundle } = media;
  let image = null;
  let videoMobile = null;
  let video = null;
  if (bundle === 'image') {
    image = media;
  } else if (bundle === 'video_file' && isMobile && media.entity.field_media_video_file_mobile.length > 0) {
    videoMobile = media.entity.field_media_video_file_mobile;
  } else {
    video = media;
  }

  return (
    // eslint-disable-next-line react/no-unknown-property
    <article typeof="schema:WebPage" className={classes}>
      <Hero
        image={image}
        video={video}
        mobileVideo={videoMobile ? videoMobile[0] : null}
        className="Hero__hero"
      >
        <div>
          <Container>
            <div className="Hero__hero__content">
              <div className="Hero__hero__content__text">
                {title && <h1 className="Hero__hero__content__text__title">{title}</h1>}
                {body && (
                  <WysiwygField
                    property="schema:text"
                    className="Hero__hero__content__text__body"
                    html={body}
                  />
                )}
              </div>
              {(linkUri || secondaryLinkUri) && (
                <div className="Hero__hero__links">
                  {linkUri && (
                    <CoreLink
                      className="Hero__hero__link Button Button--primary icon-after icon-before icon-arrow-right icon-variant-4 moving-arrow"
                      href={linkUri}
                    >
                      <span className="Hero__hero__link__text">
                        {linkTitle}
                      </span>
                    </CoreLink>
                  )}
                  {secondaryLinkUri && (
                    <CoreLink
                      className="Hero__hero__link Button Button--primary icon-after icon-before icon-arrow-right icon-variant-4 moving-arrow"
                      href={secondaryLinkUri}
                    >
                      <span className="Hero__hero__link__text">
                        {secondaryLinkTitle}
                      </span>
                    </CoreLink>
                  )}
                </div>
              )}
            </div>
          </Container>
        </div>
      </Hero>

      <div className="Paragraphs NodeLandingPageMaatjes__paragraphs">
        <Container>
          {paragraphs.length > 0 && paragraphs.map((paragraph) => {
            const targetId = paragraph.target_id;

            return (
              <Paragraph
                key={`paragraph:${targetId}`}
                id={targetId}
                entity={Immutable.fromJS(paragraph.entity)}
              />
            );
          })}
        </Container>
      </div>
    </article>
  );
};

export default NodeLandingPageMaatjes;
